import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

function render(swRegistration) {
  root.render(
    <React.StrictMode>
      <App swRegistration={swRegistration} />
    </React.StrictMode>,
  );
}

render(null);

// Installability and offline shell. onUpdate re-renders with the waiting
// registration so the app can offer a reload — a home-screen app is almost
// never hard-refreshed, so without that it would sit on an old build.
serviceWorkerRegistration.register({
  onUpdate: (registration) => render(registration),
});
